/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Astrofisica() {
  return (
    <PaginasEspecificas posicao="14" endereco="/fisica" materia="Física" />
  );
}

export default Astrofisica;
